import type { Static } from 'runtypes';
import { Literal, Record, String, Number } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { ClickstreamEventEnum } from 'bc-model';

const AiShorthandReceivedEventBrowserRuntype = BaseEventRuntype.And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_SHORTHAND_RECEIVED),
    nodeId: Number,
    originalText: String,
    summaryText: String,
    version: Literal(1),
  })
);

const AiShorthandReceivedEventServerRuntype = AiShorthandReceivedEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiShorthandReceivedBrowserEvent = Static<typeof AiShorthandReceivedEventBrowserRuntype>;
type AiShorthandReceivedServerEvent = Static<typeof AiShorthandReceivedEventServerRuntype>;

const isAiShorthandReceivedBrowserEvent = (
  obj: BaseEvent
): obj is AiShorthandReceivedBrowserEvent => {
  return obj.event === 'AI Shorthand Received';
};

const isAiShorthandReceivedServerEvent = (
  obj: BaseEvent
): obj is AiShorthandReceivedServerEvent => {
  return obj.event === 'AI Shorthand Received';
};

export {
  isAiShorthandReceivedBrowserEvent,
  isAiShorthandReceivedServerEvent,
  AiShorthandReceivedEventBrowserRuntype,
  AiShorthandReceivedEventServerRuntype,
  type AiShorthandReceivedBrowserEvent,
  type AiShorthandReceivedServerEvent,
};
